import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./routes";
import store from "./store";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/pt-br";

dayjs.extend(relativeTime);
dayjs.locale("pt-br");

import EventHub from "vue-event-hub";
Vue.use(EventHub);

import "material-design-icons-iconfont/dist/material-design-icons.css";

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import VuetifyMoney from "vuetify-money";
Vue.use(VuetifyMoney);

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD-n6jGx5Ya1lKQlp1XTlvJJXh1sMTtHtA",
    libraries: "places,visualization", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});

Vue.config.productionTip = false;

Vue.prototype.$can = function (check) {
  let user = localStorage.getItem("usuario", null);
  if (user) {
    user = JSON.parse(user);
    if (user.is_master) {
      return true;
    }
    let permissions = localStorage.getItem("permissions", null);

    if (permissions) permissions = JSON.parse(permissions);

    for (let p of permissions) {
      if (p == check) {
        return true;
      }
    }
  }

  return false;
};

Vue.config.ignoredElements = [
  "a-scene",
  "a-assets",
  "a-sky",
  "a-camera",
  "a-cursor",
  "a-animation",
  "a-entity",
  "a-box",
  "a-sphere",
];

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
